// flow weak

import React, {
    Component
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import { Multiselect } from 'react-widgets';
  import TimePicker from 'react-times';
  import 'react-times/css/classic/default.css';
  import DaAllocation from '../crud/daAllocation'
  import BuddyAllocation from '../crud/buddyAllocation'
  
  class PartnerAllocation extends Component {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = { 
        buddy_allocation : true
      };

    }
  
    componentDidMount() {
        // this.getVenueDetails();
    }

    handlecustClose = () => {
      this.setState({dialog_open_cust:false});
    };

    handleOpen=()=>{
      this.setState({dialog_open_cust:true})
    }    

    handleClick(tag){
      console.log('tag',tag)
      if(tag==='da'){
        this.setState({buddy_allocation:false})
      }
      else{
        this.setState({buddy_allocation:true})
      }
    }

  


  
    render() {
      const actionscust = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handlecustClose}
        />,
        <FlatButton
          label="Submit"
          primary={true}
          onClick={this.handleCustomerSubmit}
        />,
      ];  
      return(
        <div className='col-md-12' style={{marginTop:'1%',flexDirection:'column',display:'flex'}}> 
          <div className='col-md-12' style={{marginBottom:'1%',display:'flex',justifyContent: "center",flexDirection:'row',alignItems: 'center'}}>
            <button style={{marginRight:'1%'}} className='button1' onClick={()=>{this.handleClick('buddy')}}>Add Buddy Allocation</button>
            <button className='button1' onClick={()=>{this.handleClick('da')}}>Add DA Allocation</button>
          </div>
          <div className='row col-md-12'>
            {
              this.state.buddy_allocation ?
              <BuddyAllocation venue={this.props.venue}/>
              :
              <DaAllocation venue={this.props.venue}/>
            }
          </div>
        </div>
      );
    }
  }
  
  export default PartnerAllocation;


// WEBPACK FOOTER //
// ./src/app/views/partner/partnerAllocation/PartnerAllocation.js